<template>
  <div v-if="filters && filters.length > 1" class="market-area-filter">
    <v-btn
      v-for="(item, index) in filters"
      :key="index"
      @click="$emit('change-filter', item)"
      depressed
      class="market-area-filter__item"
      :class="{
        'market-area-filter__item--active': activeFilters.includes(item)
      }"
    >
      <span class="mr-2">{{ item }}</span>
      <v-icon small>
        {{ activeFilters.includes(item) ? "mdi-close" : "mdi-plus" }}
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "MarketAreaFilter",
  props: {
    filters: {
      type: Array,
      default: () => []
    },
    activeFilters: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss">
@import "MarketAreaFilter";
</style>
